module.exports = __webpack_public_path__ + "img/marker_route.ab6add57.svg";